module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('section', {
    staticClass: "gb-con-banner"
  }, [_c('h1', [_vm._v("软件正在改变世界")]), _vm._v(" "), _c('h2', [_vm._v("我们帮助技术人和企业了解行业趋势，并应用最新技术")])]), _vm._v(" "), _c('section', {
    staticClass: "gb-con-bl1 gb-con-sec"
  }, [_c('h2', [_vm._v("会议总览")]), _vm._v(" "), _c('img', {
    staticClass: "pc",
    attrs: {
      "src": "https://static.geekbang.org/infoq/5a4dab52b4330.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "mobile",
    attrs: {
      "src": "https://static.geekbang.org/infoq/5a4dab5654e27.png"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "gb-con-bl2 gb-con-sec"
  }, [_c('h2', [_vm._v("大会内容价值观")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("实践驱动，邀请一线专家")]), _vm._v(" "), _c('li', [_vm._v("依据软件技术采用生命周期模型，传播创新技术")]), _vm._v(" "), _c('li', [_vm._v("工程师优先于布道师，实践者优先于培训师，团队领导者优先于咨询")])])]), _vm._v(" "), _c('section', {
    staticClass: "gb-con-bl3 gb-con-sec"
  }, [_c('h2', [_vm._v("传递创新技术企业实战经验")]), _vm._v(" "), _c('p', [_vm._v("将技术采用生命周期中早期应用阶段和早期大多数阶段的技术趋势及应用带回你的团队")]), _vm._v(" "), _c('div', {
    staticClass: "container row"
  }, [_c('img', {
    attrs: {
      "src": "https://static.geekbang.org/infoq/5a4dad7d7e3db.png?imageView2",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', [_c('li', [_c('i'), _vm._v("我们关注创新和改变，而非陈词滥调")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("我们关注实践和模式，而非产品介绍。")]), _vm._v(" "), _c('li', [_c('i'), _vm._v("我们关注可落地的想法，而非天马行空。")])])])]), _vm._v(" "), _c('section', {
    staticClass: "gb-con-video gb-con-sec"
  }, [_c('h2', [_vm._v("演讲精选")]), _vm._v(" "), _c('div', {
    staticClass: "container videos"
  }, [_c('a', {
    attrs: {
      "href": "http://www.infoq.com/cn/presentations/artificial-intelligence-and-software-architecture",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "video"
  }, [_c('img', {
    attrs: {
      "src": "https://static.geekbang.org/infoq/5a4da547299c4.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("小米程序化广告交易平台（MAX）的架构实践")])]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("\n          by "), _c('span', [_vm._v("欧阳辰")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.infoq.com/cn/presentations/artificial-intelligence-and-software-architecture",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "video"
  }, [_c('img', {
    attrs: {
      "src": "https://static.geekbang.org/infoq/5a4daae2ad708.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("人工智能与软件架构")])]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("\n          by "), _c('span', [_vm._v("黄柳青")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.infoq.com/cn/presentations/golang-lua-in-Jingdong-front-end-business-system",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "video"
  }, [_c('img', {
    attrs: {
      "src": "https://static.geekbang.org/infoq/5a4da6aeda3db.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Golang+Lua 在京东前端业务系统中最佳实践")])]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("\n          by "), _c('span', [_vm._v("谢刚")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.infoq.com/cn/presentations/the-road-of-live-broadcast-of-qq-qzone",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "video"
  }, [_c('img', {
    attrs: {
      "src": "https://static.geekbang.org/infoq/5a4da5478c173.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("天下武功唯快不破：QQ 空间直播之路")])]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("\n          by "), _c('span', [_vm._v("王磊")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.infoq.com/cn/presentations/growth-hacking-recent-developments-and-best-practices",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "video"
  }, [_c('img', {
    attrs: {
      "src": "https://static.geekbang.org/infoq/5a4da75e89271.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Growth Hacking 最新动态和最佳实践")])]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("\n          by "), _c('span', [_vm._v("覃超")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.infoq.com/cn/presentations/use-apache-helix-to-build-large-scale-distributed-data-cloud-system",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "video"
  }, [_c('img', {
    attrs: {
      "src": "https://static.geekbang.org/infoq/5a4da54843fa4.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("利用 Apache Helix 构建高可用和易伸缩的大规模分布式数据云系统")])]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("\n          by "), _c('span', [_vm._v("夏磊")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d1e879e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/conf/conf.vue
// module id = 444
// module chunks = 1